export class Config {
    public anzeigetyp: 'MiniMustershop' | 'Segler'  | 'Odendahl' = 'MiniMustershop';
    public titel = 'Shop';
    public begruessung = 'Herzlich Willkommen in unserem Online-Shop.';
    public bestellnummer = true;
    public zeigeDetailsInDetailfenster = true;
    public inputHintergrundFarbe = 'white';
    public inputBorder = 'none';
    public historie = false;
    public logoInHeader = true;
    public titelInHeader = false;
    public infoKunde = '';
    public infoPwd = '';
    public topfAusblenden = false;
    public alleBestellmengen = false;
    public verfuegbareVEAnzeigen = false;
}
